/**
 * 组件映射配置
 * 维护所有可用的页面组件映射关系
 * 用于动态菜单系统和菜单管理界面
 */

export const COMPONENT_MAP = {
  // 控制台
  'Dashboard': () => import('@/views/Dashboard.vue'),
  
  // 用户管理
  'UserList': () => import('@/views/user-management/UserList.vue'),
  
  // 供应商管理  
  'SupplierList': () => import('@/views/supplier-management/SupplierList.vue'),
  
  // 代理管理
  'DynamicProxy': () => import('@/views/proxy-management/DynamicProxy.vue'),
  'StaticResidentialProxy': () => import('@/views/proxy-management/StaticResidentialProxy.vue'),
  'StaticDatacenterProxy': () => import('@/views/proxy-management/StaticDatacenterProxy.vue'),
  
  // 维护管理
  'RegionManagement': () => import('@/views/maintenance-management/RegionManagement.vue'),
  'ProxyTypeManagement': () => import('@/views/maintenance-management/ProxyTypeManagement.vue'),
  'DynamicChannelManagement': () => import('@/views/maintenance-management/DynamicChannelManagement.vue'),
  'StaticProxyProductManagement': () => import('@/views/maintenance-management/StaticProxyProductManagement.vue'),
  'MenuManagement': () => import('@/views/maintenance-management/MenuManagement.vue'),
  
  // 订单管理
  'ProxyOrders': () => import('@/views/order-management/ProxyOrders.vue'),
  'RechargeOrderManagement': () => import('@/views/order-management/RechargeOrderManagement.vue'),
  'RenewalOrderManagement': () => import('@/views/order-management/RenewalOrderManagement.vue'),
  
  // IP管理
  'IpRecords': () => import('@/views/ip-management/IpRecords.vue'),
  'IpPublicPool': () => import('@/views/ip-management/IpPublicPool.vue'),
  
  // 广告管理
  'ResourcePositionManagement': () => import('@/views/ad-management/ResourcePositionManagement.vue'),
  'ArticleManagement': () => import('@/views/ad-management/ArticleManagement.vue'),
  
  // SEO管理
  'SEOConfig': () => import('@/views/seo-management/SEOConfig.vue'),
  
  // 财务管理
  'TransactionDetails': () => import('@/views/finance-management/TransactionDetails.vue'),
  'PaymentDetails': () => import('@/views/finance-management/PaymentDetails.vue'),
  
  // 权限管理
  'AdminManagement': () => import('@/views/permission-management/AdminManagement.vue'),
  'RoleManagement': () => import('@/views/permission-management/RoleManagement.vue'),

  // 推荐官管理
  'ReferralLevel': () => import('@/views/referral-management/ReferralLevel.vue'),
  'ReferralOfficer': () => import('@/views/referral-management/ReferralOfficer.vue'),
  'ReferralAudit': () => import('@/views/referral-management/ReferralAudit.vue'),
  'ReferralDetails': () => import('@/views/referral-management/ReferralDetails.vue'),
  
  // 财务管理 - 推荐官相关
  'CommissionDetails': () => import('@/views/finance-management/CommissionDetails.vue'),
  'WithdrawalManagement': () => import('@/views/finance-management/WithdrawalManagement.vue')
}

/**
 * 组件描述信息
 * 用于在菜单管理界面显示更友好的组件信息
 */
export const COMPONENT_DESCRIPTIONS = {
  'Dashboard': { name: 'Dashboard', description: '控制台首页', path: '@/views/Dashboard.vue' },
  'UserList': { name: 'UserList', description: '用户列表页面', path: '@/views/user-management/UserList.vue' },
  'SupplierList': { name: 'SupplierList', description: '供应商列表页面', path: '@/views/supplier-management/SupplierList.vue' },
  'DynamicProxy': { name: 'DynamicProxy', description: '动态代理管理页面', path: '@/views/proxy-management/DynamicProxy.vue' },
  'StaticResidentialProxy': { name: 'StaticResidentialProxy', description: '静态住宅代理页面', path: '@/views/proxy-management/StaticResidentialProxy.vue' },
  'StaticDatacenterProxy': { name: 'StaticDatacenterProxy', description: '静态数据中心代理页面', path: '@/views/proxy-management/StaticDatacenterProxy.vue' },
  'RegionManagement': { name: 'RegionManagement', description: '地区管理页面', path: '@/views/maintenance-management/RegionManagement.vue' },
  'ProxyTypeManagement': { name: 'ProxyTypeManagement', description: '代理类型管理页面', path: '@/views/maintenance-management/ProxyTypeManagement.vue' },
  'DynamicChannelManagement': { name: 'DynamicChannelManagement', description: '动态通道管理页面', path: '@/views/maintenance-management/DynamicChannelManagement.vue' },
  'StaticProxyProductManagement': { name: 'StaticProxyProductManagement', description: '静态代理产品管理页面', path: '@/views/maintenance-management/StaticProxyProductManagement.vue' },
  'MenuManagement': { name: 'MenuManagement', description: '菜单管理页面', path: '@/views/maintenance-management/MenuManagement.vue' },
  'ProxyOrders': { name: 'ProxyOrders', description: '代理订单页面', path: '@/views/order-management/ProxyOrders.vue' },
  'RechargeOrderManagement': { name: 'RechargeOrderManagement', description: '充值订单管理页面', path: '@/views/order-management/RechargeOrderManagement.vue' },
  'RenewalOrderManagement': { name: 'RenewalOrderManagement', description: '续期订单管理页面', path: '@/views/order-management/RenewalOrderManagement.vue' },
  'IpRecords': { name: 'IpRecords', description: 'IP记录页面', path: '@/views/ip-management/IpRecords.vue' },
  'IpPublicPool': { name: 'IpPublicPool', description: 'IP公有池页面', path: '@/views/ip-management/IpPublicPool.vue' },
  'ResourcePositionManagement': { name: 'ResourcePositionManagement', description: '资源位管理页面', path: '@/views/ad-management/ResourcePositionManagement.vue' },
  'ArticleManagement': { name: 'ArticleManagement', description: '文章管理页面', path: '@/views/ad-management/ArticleManagement.vue' },
  'SEOConfig': { name: 'SEOConfig', description: 'SEO配置页面', path: '@/views/seo-management/SEOConfig.vue' },
  'TransactionDetails': { name: 'TransactionDetails', description: '交易明细页面', path: '@/views/finance-management/TransactionDetails.vue' },
  'PaymentDetails': { name: 'PaymentDetails', description: '支付明细页面', path: '@/views/finance-management/PaymentDetails.vue' },
  'AdminManagement': { name: 'AdminManagement', description: '管理员管理页面', path: '@/views/permission-management/AdminManagement.vue' },
  'RoleManagement': { name: 'RoleManagement', description: '角色管理页面', path: '@/views/permission-management/RoleManagement.vue' },
  
  // 推荐官管理
  'ReferralLevel': { name: 'ReferralLevel', description: '推荐官等级管理页面', path: '@/views/referral-management/ReferralLevel.vue' },
  'ReferralOfficer': { name: 'ReferralOfficer', description: '推荐官列表页面', path: '@/views/referral-management/ReferralOfficer.vue' },
  'ReferralAudit': { name: 'ReferralAudit', description: '推荐官申请审核页面', path: '@/views/referral-management/ReferralAudit.vue' },
  'ReferralDetails': { name: 'ReferralDetails', description: '推荐明细页面', path: '@/views/referral-management/ReferralDetails.vue' },
  
  // 财务管理 - 推荐官相关
  'CommissionDetails': { name: 'CommissionDetails', description: '佣金明细页面', path: '@/views/finance-management/CommissionDetails.vue' },
  'WithdrawalManagement': { name: 'WithdrawalManagement', description: '提现管理页面', path: '@/views/finance-management/WithdrawalManagement.vue' }
}

/**
 * 验证组件是否存在
 * @param {string} componentName 组件名称
 * @returns {boolean} 是否存在
 */
export function validateComponent(componentName) {
  return Object.prototype.hasOwnProperty.call(COMPONENT_MAP, componentName)
}

/**
 * 获取所有可用组件列表
 * @returns {Array} 组件名称数组
 */
export function getAvailableComponents() {
  return Object.keys(COMPONENT_MAP)
}

/**
 * 获取组件描述信息
 * @param {string} componentName 组件名称
 * @returns {Object|null} 组件描述信息
 */
export function getComponentDescription(componentName) {
  return COMPONENT_DESCRIPTIONS[componentName] || null
}

/**
 * 获取组件路径
 * @param {string} componentName 组件名称
 * @returns {string} 组件路径
 */
export function getComponentPath(componentName) {
  const description = getComponentDescription(componentName)
  return description ? description.path : ''
}